import { render, staticRenderFns } from "./Rede.vue?vue&type=template&id=22de3ac9&"
import script from "./Rede.vue?vue&type=script&lang=js&"
export * from "./Rede.vue?vue&type=script&lang=js&"
import style0 from "./Rede.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports